module.exports = __webpack_public_path__ + "img/coupon_bg.2afbc68.png";